import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';

export const useIsTransportationProviderUser = (): boolean => {
  const user = useAppSelector(userSlice.selectUserInfo);

  if (!user) {
    return false;
  }

  return (
    user.access?.userRoles?.includes('tp.transportationprovider.user') || false
  );
};
